<template>
  <login-layout title="星轨询盘管理">
    <div class="dingding-tip-box">
      <h2>仅支持通过钉钉工作台访问</h2>
      <div class="dingding-tip-img">
        <img
          src="../../assets/images/dingdingtip.jpg"
          width="160"
          height="160"
        >
      </div>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/account/LoginLayout'
export default {
  'name': 'AccoutDingDing',
  components: {
    LoginLayout
  },
  data () {
    return {
    }
  },
  async mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.dingding-tip-box {
  h2 {
    font-size: 14px;
    font-weight: bold;
    margin:-10px 0 50px;
    text-align: center;
  }
  .dingding-tip-img {
    text-align: center;
  }
}
</style>
